const initialState = {
    isSheetProductsCommentOpen: false,
};

const sheetProductComments = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_SHEET_PRODUCT_COMMENTS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default sheetProductComments;
